import { actions } from '../actions/monitor';

export const initialState = {
  firstResult: 0,
  maxResult: 51,
  queryParameter: '',
  organizationId: null
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  if (type === actions.paginate || type === actions.request) {
    return {
      ...state,
      ...payload
    };
  }

  if (type === actions.paginateSuccess && !payload.length) {
    const { firstResult, maxResult } = state;
    return {
      ...state,
      firstResult: (firstResult) ? (firstResult - maxResult) : 0
    };
  }

  return state;
};
